// extracted by mini-css-extract-plugin
export default {"heading":"table_heading__gGpVU","data":"table_data__qbOPW","roundedTable":"table_roundedTable__JpZxP","fixTableHead":"table_fixTableHead__RmjOh","tableHead":"table_tableHead__JZOD8"};